import { render, staticRenderFns } from "./bestquality.vue?vue&type=template&id=3cd33643&scoped=true"
import script from "./bestquality.vue?vue&type=script&lang=js"
export * from "./bestquality.vue?vue&type=script&lang=js"
import style0 from "./bestquality.vue?vue&type=style&index=0&id=3cd33643&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd33643",
  null
  
)

export default component.exports